'use client';
import React from 'react';
import { Search, ArrowUpDown } from 'lucide-react';

interface SearchHeaderProps {
  searchQuery: string;
  onSearchChange: (q: string) => void;
  viewMode: 'grid' | 'map';
  onViewModeChange: (m: 'grid' | 'map') => void;
  sortBy: string;
  onSortChange: (s: string) => void;
  resultCount: number;
  totalCount: number;
  hideResultsRow?: boolean;
}

const SORT_OPTIONS = [
  { value: 'rating-desc', label: 'KHDA Rating: Best First' },
  { value: 'fee-asc', label: 'Annual Fee: Low to High' },
  { value: 'fee-desc', label: 'Annual Fee: High to Low' },
  { value: 'travel-asc', label: 'Travel Time: Nearest First' },
  { value: 'name-asc', label: 'School Name: A–Z' },
];

export default function SearchHeader({
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  resultCount,
  hideResultsRow,
}: SearchHeaderProps) {
  return (
    <div className="space-y-2">
      {/* Search Bar */}
      <div className="relative">
        <Search size={17} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search by school, community, curriculum..."
          className="w-full pl-10 pr-4 py-3 border border-border rounded-xl bg-white text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all"
        />
      </div>

      {/* Mobile results row — hidden on desktop, hidden when hideResultsRow=true */}
      {!hideResultsRow && (
        <div className="sm:hidden flex items-center justify-between gap-2" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', minWidth: 0 }}>
          <span className="text-xs text-muted-foreground shrink-0">
            <span className="font-semibold text-foreground tabular-nums">{resultCount}</span> schools
          </span>
          <div className="flex items-center gap-1 border border-border rounded-lg px-2 py-1.5 bg-white" style={{ minWidth: 0, maxWidth: '65%' }}>
            <ArrowUpDown size={12} className="text-muted-foreground shrink-0" />
            <select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="text-xs bg-transparent text-foreground focus:outline-none"
              style={{ minWidth: 0, maxWidth: '100%' }}
            >
              {SORT_OPTIONS.map((opt) => (
                <option key={`msort-${opt.value}`} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}